import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import apiAuth from 'constants/api/apiAuth';
import constant from 'constants/constant';
import util from 'helpers/util';
import useAuth from "utils/auth/hooks";

export default function ChangePasswordForm(props) {
  const { methods, data } = useAuth();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  function submit(value) {
    setLoading(true);
    apiAuth.changePassword({
      email: data?.userData?.userInfo?.email,
      ...value
    }).then((res) => {
      setLoading(false);
      if(res.success){
        message.info(res.message);
        form.resetFields();
        props.onFinish();
      }
      else{
        message.error(<pre style={{textAlign:"left"}}>{res.message}</pre>);
      }
    }).catch((err) => {
      util.displayApiError(err);
    });
  }  

  return (
    <Form
      name="changePasswordForm"
      layout="vertical"
      requiredMark="optional"
      initialValues={{
        remember: true,
      }}
      form={form}
      onFinish={submit}
    >
      <Form.Item
        name="currentPassword" label="Current Password"
        rules={[
          {
            required: true,
            message: "Please input your current Password!",
          },
        ]}
      >
        <Input.Password placeholder="Current Password" />
      </Form.Item>
      <Form.Item
        name="newPassword" label="New Password"
        rules={[
          {
            required: true,
            message: "Please input your new Password!",
          },
        ]}
      >
        <Input.Password placeholder="New Password" />
      </Form.Item>
      <Form.Item
        name="confirmNewPassword" label="Confirm New Password"
        rules={[
          {
            required: true,
            message: "Please input your new Password!",
          },
        ]}
      >
        <Input.Password placeholder="Confirm New Password" />
      </Form.Item>
      <Form.Item>
        <div style={{display:"flex", justifyContent:"space-between"}}>
          <Button
            type="primary"
            htmlType="submit"
            style={{minWidth:"120Px"}}
            loading={loading}
          >
            Save
          </Button>
          {props.showLogout ?
            <Button
              type="danger"
              style={{minWidth:"120Px"}}
              onClick={methods.handleLogout}
            >
              Logout
            </Button>
            :<></>
          }
        </div>
      </Form.Item>
    </Form>
  )
}
